import { createBrowserHistory, createHashHistory } from 'history'

export const hashHistory = createHashHistory()
export const history = createBrowserHistory()



// WEBPACK FOOTER //
// ./src/utils/history.ts